import { render, staticRenderFns } from "./SingleRankingDisplay.vue?vue&type=template&id=16d238ee&scoped=true"
import script from "./SingleRankingDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleRankingDisplay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SingleRankingDisplay.vue?vue&type=style&index=0&id=16d238ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d238ee",
  null
  
)

export default component.exports